import axios from '../components/shared/axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const addUnitOffer = async (values) =>
  await axios.post(`${baseURL}/unit-offer`, values);

export const addUnitOffers = async (values) =>
  await axios.post(`${baseURL}/unit-offers`, values);

export const getUnitOffer = async (id) => {
  const params = { unitOfferId: id };
  return await axios.get(`${baseURL}/unit-offers`, { params });
};

export const getUnitOffers = async (pageNo, pageSize, param) => {
  //  Code after the BE refactors for paginated unit offer
  //   let params = {};
  //   if (param) params = { pageNo, pageSize, ...param };
  //   else params = { pageNo, pageSize };
  const params = param;
  return await axios.get(`${baseURL}/unit-offers`, { params });
};

export const updateUnitOffer = async (id, params) => {
  return await axios.put(`${baseURL}/unit-offer/${id}`, params);
};

export const deleteUnitOffer = async (params) => {
  return await axios.delete(
    `${baseURL}/unit-offer?unitOfferId=${params.unitOfferId}`
  );
};

export const getCalendarAdmin = async (pageNo, pageSize, param) => {
  let params;
  if (param) params = { pageNo, pageSize, ...param };
  else params = { pageNo, pageSize };
  return await axios.get(`${baseURL}/dashboard-calendar-admin`, {
    params
  });
};
